import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { useCallback } from "react";
import { Fragment } from "react/jsx-runtime";
import { COLS_BY_TEMPLATE, ROWS_BY_TEMPLATE } from "../../constants/constants";
import { useWallAnalytics } from "../../context/context-analytics/context-analytics";
import { useWallProvider } from "../../context/context-wall/context-wall";
import { LayoutPostContainer } from "../LayoutPostContainer/LayoutPostContainer";

export type ScreenLayoutTemplateProps = {
  screen: SliceWallScreenState;
};

export function ScreenLayoutTemplate({ screen }: ScreenLayoutTemplateProps) {
  const provider = useWallProvider();
  const { trigger } = useWallAnalytics();

  const onHandleMouse = useCallback(
    (index: number, x: number, y: number) => {
      provider?.onPostInteracted(screen.id, screen.layoutPostPositions[index]);
      trigger(
        EventPayloadType.PostActioned,
        {
          flyout:
            screen.layoutPostPositions[index]?.post?.flyoutType ?? undefined,
          position: {
            x,
            y,
          },
          screen: screen.index,
        },
        screen.layoutPostPositions[index]?.post?.id ?? undefined,
        screen.layout?.id ?? undefined,
      );
    },
    [
      provider,
      screen.id,
      screen.index,
      screen.layout?.id,
      screen.layoutPostPositions,
      trigger,
    ],
  );

  if (!screen.layout.template) {
    console.error(`Layout template not found (${screen.layout.id})`);
    return null;
  }

  const cols = COLS_BY_TEMPLATE[screen.layout.template] ?? 1;
  const rows = ROWS_BY_TEMPLATE[screen.layout.template] ?? 1;

  return (
    <div className="flex flex-row w-full h-full">
      {Array.from({ length: cols }).map((_, col) => {
        return (
          <div key={col} className="flex-1 h-full">
            <div className="flex flex-col h-full">
              {Array.from({ length: rows }).map((_, row) => {
                const index = col + row * cols;

                return (
                  <Fragment key={index}>
                    {!!screen.layoutPostPositions[index] && (
                      <div
                        className="flex-1 w-full"
                        style={{
                          padding: screen.layout.padding ?? 0,
                        }}
                        onPointerDown={(e) =>
                          onHandleMouse(index, e.screenX, e.screenY)
                        }
                      >
                        <LayoutPostContainer
                          screen={screen}
                          layout={screen.layout}
                          position={screen.layoutPostPositions[index]}
                        />
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
